module.exports = __webpack_public_path__ + "img/donut_qty.f2ea4d4c.svg";